import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Trans, useTranslation } from 'react-i18next'
import CustomCheckInput from '../../../common/form/CustomCheckInput'

import classes from './CoachOnboardingStepsAdminModal.module.scss'
import Modal from '../../../common/Modal'

const CoachOnboardingStepsAdminModal = ({ isOpen, onClose, onboardingSteps, onboardingStatus, lastModified, completedSteps, totalSteps }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      contentLabel='CoachOnboardingStepsAdminModal'
      className={classes.modalWrapper}
      onClose={onClose}
    >
      <div className={classNames(classes.modalContent, 'd-flex flex-column justify-content-center')}>
        <h5 className={classes.title}>{t('communities.onboarding.statusDetails')}</h5>
        <div className='px-2'>
          <div className='d-flex align-items-center justify-content-between'>
            <p className={classes.statusText}>{onboardingStatus} {lastModified}</p>
            <p className={classes.totalCount}>
              <Trans
                i18nKey='communities.onboarding.completeCount'
                values={{ completed: completedSteps, total: totalSteps }}
                components={{ completedSpan: <span className={classes.completedCount} /> }}
              />
            </p>
          </div>
          <div className={classes.stepsWrapper}>
            <div className={classNames(classes.stepsContainer, 'd-flex flex-column justify-content-center')}>
              {onboardingSteps.map(step => (
                <div key={step.id} className={classNames(classes.step, 'd-flex flex-column')}>
                  <p className={classes.stepTitle}>{step.title}</p>
                  {step.coachOnboardingItems.map(item => (
                    <CustomCheckInput
                      key={item.id}
                      type='checkbox'
                      classNames={{
                        checkBoxInput: `${classes.roundedCheckbox} ${item.completed ? classes.roundedCheckboxComplete : ''}`,
                        checkMark: classes.checkBoxCheckMark,
                      }}
                      id={`step-check-${step.id}`}
                      checked={true}
                      readOnly
                      label={item.title}
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

CoachOnboardingStepsAdminModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onboardingSteps: PropTypes.array,
  onboardingStatus: PropTypes.string,
  lastModified: PropTypes.string,
  completedSteps: PropTypes.number,
  totalSteps: PropTypes.number,
}

export default CoachOnboardingStepsAdminModal
